import * as React from 'react';
import { DOCUMENT_SCROLL_DISABLE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';
export function useDisablePageScroll(active) {
  React.useEffect(function () {
    if (!active) {
      return;
    }

    var subscriber = new Subscriber();
    getGlobalBehaviors().subscribe(DOCUMENT_SCROLL_DISABLE, subscriber);
    return function () {
      getGlobalBehaviors().unsubscribe(DOCUMENT_SCROLL_DISABLE, subscriber);
    };
  }, [active]);
}